/* src/app/shared/dialogs/illustration-dialog/illustration-dialog.component.scss */
.dialog-main-container {
  display: flex;
  flex-direction: column;
  width: 840px;
  height: 60vh;
  border-radius: 16px;
}
.dialog-main-container .dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
  border-bottom: 1px solid #dfdfdf;
}
.dialog-main-container .dialog-header img {
  cursor: pointer;
}
.dialog-main-container .dialog-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
  border-top: 1px solid #dfdfdf;
}
.dialog-main-container .illustrations {
  display: flex;
  flex-wrap: wrap;
  gap: 24px 22px;
  padding: 24px;
  padding-right: 20px !important;
  overflow-y: auto;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}
.dialog-main-container .illustrations .illustration {
  width: 180px;
  height: 180px;
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 12px;
}
.dialog-main-container .illustrations .illustration:hover {
  background-color: #f2f2f2;
}
.dialog-main-container .illustrations .selected {
  border: 2px solid #6e89da;
}
::ng-deep .mdc-dialog__container {
  border-radius: 16px !important;
}
::ng-deep .mdc-dialog__container .mdc-dialog__surface {
  box-shadow: none !important;
  border-radius: 16px !important;
}
/*# sourceMappingURL=illustration-dialog.component.css.map */
